<ng-template [ngIf]="hasLabel===false">
  <ng-template [ngIf]="session.isFrench() && session.displayHelpIfAvailable()">
  <div style="display:inline">
    <span  style="padding-left: 5px; padding-right: 5px;">
  <!--    <a class="naked" target="_blank" [href]="urlToHelpFr" ngbTooltip="Voir l'aide sur cette section."><i class="fa fa-question-circle emprez-vert-agrume"></i></a>-->
      <ng-template [ngIf]="displayPopup===true"><a class="naked" target="_blank" [href]="urlToHelpFr" ngbTooltip="Voir l'aide sur cette section." [disableTooltip]="disableTooltip">
        <i class="fad fa-info-circle emprez-duo-icon" ></i>
      </a></ng-template>
      <ng-template [ngIf]="displayPopup===false"><a class="naked" target="_blank" [href]="urlToHelpFr">
        <i class="fad fa-info-circle emprez-duo-icon"></i>
      </a></ng-template>
    </span>
  </div>
  </ng-template>
  <ng-template [ngIf]="!session.isFrench() && session.displayHelpIfAvailable()">
  <div style="display:inline">
    <span  style="padding-left: 5px; padding-right: 5px;">
  <!--    <a class="naked" target="_blank" [href]="urlToHelpOther" ngbTooltip="See Help on This Section."><i class="fa fa-question-circle emprez-vert-agrume"></i></a>-->
      <ng-template [ngIf]="displayPopup===true"><a class="naked" target="_blank" [href]="urlToHelpOther" ngbTooltip="See Help on This Section." [disableTooltip]="disableTooltip">
        <i class="fad fa-info-circle emprez-duo-icon"></i>
      </a></ng-template>
      <ng-template [ngIf]="displayPopup===false"><a class="naked" target="_blank" [href]="urlToHelpOther" >
        <i class="fad fa-info-circle emprez-duo-icon"></i>
      </a></ng-template>
    </span>
  </div>
  </ng-template>
</ng-template>

<ng-template [ngIf]="hasLabel===true">
  <ng-template [ngIf]="session.isFrench()">
  <div style="display:inline">
    <span  style="padding-left: 5px; padding-right: 5px;">
      <a class="naked" target="_blank" [href]="urlToHelpFr" >{{label}}</a>
    </span>
  </div>
  </ng-template>

  <ng-template [ngIf]="!session.isFrench()">
  <div style="display:inline">
    <span  style="padding-left: 5px; padding-right: 5px;">
      <a class="naked" target="_blank" [href]="urlToHelpOther" >{{label}}</a>
    </span>
  </div>
  </ng-template>


</ng-template>
